import { useEffect, useState } from "react";
import { BagIcon } from "../../assets";
import styles from "./style.module.css";
import { Tranzakt } from "tranzakt-react-sdk";
import { CartContentHeader } from "../cartContent/cartContentHeader";
import { RootState } from "../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import { setCheckoutVisibility } from "../../redux/slices/checkoutSlice";
import { CheckoutItem } from "./checkoutItem";

const REACT_APP_SECRET_KEY = process.env.REACT_APP_API_SECRET_KEY || ""

const tranzakt = new Tranzakt(REACT_APP_SECRET_KEY); 

export interface OrderSummaryProps 
{
  numberOfItems: number;
  subtotal: number;
  deliveryFee: number;
  tax: number;
  storeDiscount: number;
}

// interface Invoice {
//   id: string;
//   title: string;
//   collectionName: string;
//   payerName: string;
//   payerEmail: string;
//   payerPhoneNumber: string;
//   billerName: string;
//   billerAddress: string;
//   billerEmail: string;
//   amount: number;
//   serviceCharge?: number;
//   vat: number;
//   totalAmount: number;
//   invoiceStatus: "Unpaid" | "Paid" | "Invalidated";
//   serviceFeePayer: "Payer";
//   settlementFrequency: "Instant" | "Daily";
//   type: "Test" | "Live";
//   paymentUrl: string;
//   dateCreated: string;
//   dateModified: string;
//   paymentDate: string;
//   paymentMethod: "Card" | "BankTransfer" | "USSD";
//   invoiceBeneficiaries: Array<{
//     amount: string;
//     linkedAccountId: string;
//     accountName: string;
//     accountNumber: string;
//     bankName: string;
//     businessName: string;
//   }>;
//   billerMetaData?: Record<string, string>;
//   callBackUrl?: string;
// }

export const OrderSummary: React.FC<OrderSummaryProps> = ({
  numberOfItems,
  subtotal,
  deliveryFee,
  tax,
  storeDiscount,
}) => {

  const dispatch = useDispatch();
  const isCheckoutOpen = useSelector((state: RootState) => state.CheckoutState.isCheckoutOpen)
  const checkoutItems = useSelector((state: RootState) => state.ArtItem.items);

  const total = (subtotal || 0) + (deliveryFee || 0) + (tax || 0) - (storeDiscount || 0);

//   console.log("Order Summary:");
// console.log(`Number of Items: ${numberOfItems}`);
// console.log(`Subtotal: ${subtotal}`);
// console.log(`Delivery Fee: ${deliveryFee}`);
// console.log(`Tax: ${tax}`);
// console.log(`Store Discount: ${storeDiscount}`);
// console.log(`Total: ${total}`);




  
  // const handleApplyClick = () =>{
  //   console.log("Apply Clicked");
  // }

  const handleProceedToCheckout = () => {
    dispatch(setCheckoutVisibility(true)); 
  }

  const handlePay = async () => {
    // console.log("Clicked Checkout Button Boiiii");
    // console.log("react secret: " + REACT_APP_SECRET_KEY)

    try {
      const invoice = await tranzakt.createInvoice({
        collectionId: "01JQCFXDMQ2RSWM931NXM1P1E7",
        payerEmail: "kanayoemezi@gmail.com",
        payerName: "Elvis Emezi",
        payerPhoneNumber: "08188571304",
        title: "Checkout Invoice",
        amount: total,
        // amount: total,
        // invoiceBeneficiaries: [
        //   {
        //     linkedAccountId: "37a71e2e-ed54-4e46-a3a9-47a211c352ea",
        //     amount: 20000,
        //   },
        // ],
        callBackUrl: "https://openx-web.onrender.com/",
        billerMetaData: {
          "order-id": "12345",
        },
      });

      window.open(invoice.data.paymentUrl, "_blank");
 
      console.log("Invoice Created:", invoice);
    } catch (error: unknown) {
      if (error instanceof Error) {
        console.error(`${error.name}: ${error.message}`);
      } else if (typeof error === "object" && error !== null) {
        const errObj = error as { status?: number; message?: string; type?: string; errors?: any };
        console.error(`${errObj.status || "Unknown Status"}: ${errObj.message || "No message"}`);
        console.error("Error type:", errObj.type || "Unknown type");
        console.error("Details:", errObj.errors || "No details available");
      } else {
        console.error("An unknown error occurred:", error);
      }
    }
  };

  const formatter = new Intl.NumberFormat('en-NG', {
    style: 'currency',
    currency: 'NGN',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  const [isOptionSelected, setOptionSelected] = useState(false);

  const handleOptionsClick = () => {
    setOptionSelected(!isOptionSelected);
  };
  
  const header = isCheckoutOpen ? "Checkout" : "Order Summary";
  

  const itemCount = useSelector((state: RootState) => state.ArtItem.items.length)

  useEffect(() => {document.documentElement.style.setProperty("--summary-width", isCheckoutOpen ? "32.43%" : "18.68%")}, [isCheckoutOpen])

  return (
    <div className={styles.container}>
      <CartContentHeader headerTitle={header} />

      {!isCheckoutOpen ? (
        <>
          <div className={styles.bagContainer}>
            <BagIcon />
          </div>

          {itemCount > 0 && (
            <>
              <div className={styles.orderBreakdownContainer}>
                <div className={styles.orderBreakdown}>
                  <div>No. of Items</div>
                  <div>Subtotal</div>
                  <div>Delivery Fee</div>
                  <div>Tax</div>
                  <div>Store Discount</div>
                </div>

                <div className={styles.orderPrices}>
                  <div>{numberOfItems}</div>
                  <div>{formatter.format(subtotal)}</div>
                  <div>{formatter.format(deliveryFee)}</div>
                  <div>{formatter.format(deliveryFee)}</div>
                  <div>-{formatter.format(storeDiscount)}</div>
                </div>
              </div>

              <div className={styles.voucherEntryContainer}>
                {/* <div className={styles.voucherEntry}>
          <label>Voucher</label>
          <input className={styles.voucherInput}></input>
          <button onClick={handleApplyClick} className={styles.applyButton}>
            Apply
          </button>
        </div> */}
              </div>

              <div className={styles.checkoutContainer}>
                <div className={styles.totalDisplay}>
                  <span className={styles.total}>Total</span>
                  <span className={styles.figure}>
                    {formatter.format(total)}
                  </span>
                </div>
                <button
                  onClick={handleProceedToCheckout}
                  className={styles.checkoutButton}
                >
                  Proceed To Checkout
                </button>
              </div>
            </>
          )}
        </>
      ) : (
        <div>
          {checkoutItems.map((item, index) => (
            <div>
              <CheckoutItem
                itemImage={item.itemImage}
                itemName={item.itemName}
                itemPrice={formatter.format(Number(item.itemPrice))}
                itemQuantity={index.toString()}
              />
            </div>
          ))}

          <div className={styles.subTtlCont}>
            <span className={styles.checkoutSubtotal}>Subtotal</span>
            <span className={styles.checkoutTotal}>
              {formatter.format(total)}
            </span>
          </div>

          <div className={styles.ttlCont}>
            <span className={styles.checkoutSubtotal}>Total</span>
            <span className={styles.checkoutTotal}>
              {formatter.format(total)}
            </span>
          </div>

          <div className={styles.payOption}>
            {/* <div> */}
              <div className={`${styles.optionButton} ${isOptionSelected ? styles.selected : ''}`} 
              onClick={handleOptionsClick} id="optionButton">
                <div className={styles.innerCircle}></div>
              </div>
            {/* </div> */}

           <div className={styles.payDtsCnt}>
             <div className={styles.pay}>Pay with Tranzakt</div>
            <div className={styles.intTxt}>
              Make your payment directly with the Tranzakt app, you will be
              immediately redirected to the payment page
            </div>
            </div>
          </div>

          <button disabled={!isOptionSelected} onClick={handlePay} className={styles.checkoutButton}>
            Pay
          </button>
        </div>
      )}
    </div>
  );
};
